export class AnalystModel {
    constructor(
      public analystId: string,
      public firstName: string,
      public lastName: string,
      public title: string,
      public phone: string,
      public fax: string,
      public email: string) {}
  }
